module.exports = __webpack_public_path__ + "img/ic-devices-hover.f7311f70.svg";